import React from "react";
import BorrowerSourcing from "./BorrowerSourcing.jsx";

/** Complex BTL sourcing — same journey as BTL with HMO / MUFB / STL / Portfolio filters. */
export default function ComplexBtlSourcing() {
  return <BorrowerSourcing variant="complex-btl" />;
}
